import { POD_SERIES_COLORS } from '@/features/monitoring/api';

type PodSeriesItem = {
  pod: string;
  color?: string;
};

export const assignOrderedPodSeriesColors = <T extends PodSeriesItem>(podHistoryRaw: T[]) => {
  return [...podHistoryRaw]
    .sort((a, b) => a.pod.localeCompare(b.pod))
    .map((pod, index) => ({
      ...pod,
      color: POD_SERIES_COLORS[index % POD_SERIES_COLORS.length],
    }));
};
